import store from "@/store";
import request from "@/api/index";

/**
 * @description 通过该函数发起的请求缓存在vuex中，多次调用不再发起请求; 仅判断请求地址，不判断请求参数;
 * @param url {String}
 * @param params {Object}
 * @param method {String}
 * @return  {Promise}
 * @author 2021-5-28
 */
// eslint-disable-next-line no-unused-vars
const cacheRequest = function ({ url, params, data, method }) {
  const PATH = url;
  let respone = store.getters["cache/getCacheByPath"](`${PATH}>respone`);
  let promise = store.getters["cache/getCacheByPath"](`${PATH}>promise`);
  // 缓存的结果
  if (respone) return Promise.resolve(respone);
  // 之前已发送过相同请求
  if (promise) return promise;

  // 新请求
  promise = request({
    method,
    url,
    params,
    data,
  })
    .then((res) => {
      store.commit("cache/setCache", { key: `${PATH}>respone`, value: res });
      store.commit("cache/clearCache", `${PATH}>promise`);
      return res;
    })
    .catch((err) => {
      store.commit("cache/clearCache", `${PATH}>promise`);
      return err;
    })
    .finally(() => {
      store.commit("cache/clearCache", `${PATH}>promise`);
    });
  // 缓存已发送请求
  store.commit("cache/setCache", { key: `${PATH}>promise`, value: promise });
  return promise;
};

export default cacheRequest;

// 暂时禁用请求缓存
// export default request;
